import { B, fonts, Btn } from "../../../components/UI";

// Categories tab handles category CRUD and visibility toggles.
export default function CategoriesTab({
  categories,
  showCatFm,
  setShowCatFm,
  editCat,
  setEditCat,
  nextCategoryOrder,
  setCrudBusy,
  showToast,
  handleToggleCat,
  handleDeleteCat,
  isSuperAdmin,
  CategoryForm,
}) {
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18 }}>
        <p style={{ margin: 0, fontSize: 12, color: B.textLight, fontFamily: fonts.body }}>Manage product categories</p>
        {!showCatFm && !editCat && <Btn onClick={() => setShowCatFm(true)} variant="primary">+ Add Category</Btn>}
      </div>
      {(showCatFm || editCat) && (
        <CategoryForm initial={editCat} nextOrder={nextCategoryOrder()}
          onDone={() => { setShowCatFm(false); setEditCat(null); }}
          showToast={showToast}
          onSavingChange={setCrudBusy} />
      )}
      {categories.map(c => (
        <div key={c.id} style={{ display: "flex", alignItems: "center", gap: 14, padding: "12px 16px", background: c.active ? B.white : "#FFF8F5", border: `1px solid ${c.active ? B.borderLight : B.orangeMid}`, borderRadius: 12, marginBottom: 8, opacity: c.active ? 1 : 0.65 }}>
          <div style={{ width: 44, height: 44, background: B.orangeFaint, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0, overflow: "hidden" }}>
            {c.bannerUrl ? <img src={c.bannerUrl} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : c.icon}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 2 }}>
              <span style={{ fontWeight: 700, fontSize: 13, color: B.text, fontFamily: fonts.adminDisplay }}>{c.name}</span>
              {!c.active && (
                <span style={{ fontSize: 10, background: B.redLight, color: B.red, border: `1px solid ${B.red}33`, padding: "1px 8px", borderRadius: 4, fontWeight: 700, fontFamily: fonts.body }}>Hidden</span>
              )}
            </div>
            <div style={{ fontSize: 11, color: B.textLight, fontFamily: fonts.body }}>/{c.slug} · Order: {c.order}</div>
          </div>
          <div style={{ display: "flex", gap: 6 }}>
            <Btn onClick={() => { setEditCat(c); setShowCatFm(false); }} variant="ghost" small>Edit</Btn>
            <Btn onClick={() => handleToggleCat(c)} variant={c.active ? "danger" : "success"} small>
              {c.active ? "Hide" : "Show"}
            </Btn>
            {isSuperAdmin && <Btn onClick={() => handleDeleteCat(c)} variant="danger" small>Delete</Btn>}
          </div>
        </div>
      ))}
    </div>
  );
}
